import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import { AddToDashboardWrapper } from "app/pages/industry-analysis/overview/widgets/high-level-metrics/single/chartFiltersAndLegends/AddToDashboard";
import { ExcelDownload } from "app/pages/industry-analysis/overview/widgets/high-level-metrics/single/chartFiltersAndLegends/ExcelDownload";
import { GranularitySwitcher } from "app/pages/industry-analysis/overview/widgets/high-level-metrics/single/chartFiltersAndLegends/GranularitySwitcher";
import { Legends } from "app/pages/industry-analysis/overview/widgets/high-level-metrics/single/chartFiltersAndLegends/Legends";
import { PngDownload } from "app/pages/industry-analysis/overview/widgets/high-level-metrics/single/chartFiltersAndLegends/PngDownload";
import { useNoRenderA2D } from "app/pages/industry-analysis/frame/WithNoRender";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { useHighLevelMetricsContext } from "../context";

const ActionItemsContainer = styled(FlexRow)<{ width: string }>`
    @media print {
        display: none;
    }
    ${({ width }) => `width: ${width};`};
    justify-content: flex-end;
`;

export const FiltersAndActionItems = ({ chartRef }) => {
    const { legendItems } = useHighLevelMetricsContext();

    const { isA2DAvailable } = useNoRenderA2D();
    const isAvailable = isA2DAvailable;
    const shouldRenderLegends = legendItems && legendItems.length > 0;

    return (
        <Flex
            justifyContent="space-between"
            alignItems="center"
            padding="24px 0"
        >
            {shouldRenderLegends ? <Legends /> : null}
            <ActionItemsContainer width={shouldRenderLegends ? "60%" : "100%"}>
                <GranularitySwitcher />
                <ExcelDownload />
                <PngDownload chartRef={chartRef} />
                {isAvailable ? <AddToDashboardWrapper /> : null}
            </ActionItemsContainer>
        </Flex>
    );
};
